<template>
  <el-dialog
    :visible.sync="visibleProxy"
    :show-close="false"
    width="860px"
    :close-on-click-modal="false"
    custom-class="booking-day-list-dialog"
    append-to-body
  >
    <div class="inner">
      <div class="header">
        <div class="title">
          <i class="el-icon-date"></i>
          {{ dateText }} 预约列表
          <span class="total">共 {{ bookings.length }} 条</span>
        </div>
        <span class="close" @click="visibleProxy = false"><i class="el-icon-close"></i></span>
      </div>

      <div class="body">
        <el-table
          :data="bookings"
          style="width: 100%"
          max-height="420"
          :row-class-name="tableRowClassName"
          @row-click="handleRowClick"
        >
          <el-table-column label="预约时间" width="150">
            <template slot-scope="scope">
              <div class="time-cell">
                <div class="time-text">{{ scope.row.startTime || '无' }} - {{ scope.row.endTime || '无' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="memberName" label="会员姓名" width="120">
            <template slot-scope="scope">
              <div class="member-cell">
                <div class="member-avatar">{{ (scope.row.memberName || '无').charAt(0) }}</div>
                <span>{{ scope.row.memberName || '无' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="roomName" label="房间" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.roomName || '无' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="110">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="mini" disable-transitions>
                {{ statusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.projectName || '无' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="remark-text">{{ scope.row.remark || '无' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="72" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.stop="handleRowClick(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="footer">
        <el-button size="small" @click="visibleProxy = false">关 闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { statusText as appointmentStatusText } from '@/utils/appointmentHelper'

export default {
  name: 'BookingDayListDialog',
  props: {
    visible: { type: Boolean, default: false },
    date: { type: String, default: '' },
    bookings: { type: Array, default: () => [] }
  },
  computed: {
    visibleProxy: {
      get() { return this.visible },
      set(v) { this.$emit('update:visible', v) }
    },
    dateText() {
      return this.date || '无'
    }
  },
  methods: {
    statusText(status) {
      return appointmentStatusText(status)
    },
    getStatusType(status) {
      if (status === 'booked') return 'primary'
      if (status === 'serving') return 'success'
      if (status === 'converted') return 'info'
      if (status === 'cancelled') return 'danger'
      return 'info'
    },
    tableRowClassName({ row }) {
      if (row.status === 'cancelled') return 'cancelled-row'
      if (row.status === 'serving') return 'serving-row'
      return ''
    },
    handleRowClick(row) {
      this.$emit('select', row)
    }
  }
}
</script>

<style lang="scss">
.booking-day-list-dialog {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 0; }

  .inner {
    display: flex;
    flex-direction: column;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    border-bottom: 1px solid rgba(59, 130, 246, 0.12);

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 700;
      color: #1e293b;

      i { color: #3b82f6; }

      .total {
        font-size: 13px;
        font-weight: 500;
        color: #64748b;
      }
    }

    .close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      color: #64748b;

      &:hover {
        background: rgba(0, 0, 0, 0.08);
        color: #0f172a;
      }
    }
  }

  .body {
    padding: 16px 20px 8px;

    .el-table {
      border-radius: 8px;
      border: 1px solid #e2e8f0;

      &::before { display: none; }

      th {
        background: #f8fafc !important;
        color: #475569;
        font-weight: 600;
        font-size: 13px;
      }

      td {
        font-size: 13px;
        cursor: pointer;
      }

      tr:hover > td {
        background: #f8fafc !important;
      }
    }

    .cancelled-row { opacity: 0.65; }
    .serving-row { background: rgba(34, 197, 94, 0.04); }

    .time-text {
      color: #1e293b;
      font-weight: 500;
    }

    .member-cell {
      display: flex;
      align-items: center;
      gap: 8px;

      .member-avatar {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        flex-shrink: 0;
      }
    }

    .remark-text { color: #94a3b8; }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    padding: 12px 20px 16px;
    border-top: 1px solid #f1f5f9;
  }
}
</style>
